/* eslint-disable no-unused-vars */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import t from '../../lib/I18n';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import HelpIcon from '../../components/general/HelpIcon';
import Icon from '../../components/general/Icon';
import ToggleInput from '../../components/form/ToggleInput';
import TrackingActions from "../../actions/TrackingActions";


class RailcardJobCentrePlusCheckbox extends PureComponent {
    static propTypes = {
        checked: PropTypes.bool,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        onDisabledClick: PropTypes.func,
    };

    static defaultProps = {
        checked: false,
        disabled: false,
        onChange: _.noop,
        onDisabledClick: _.noop,
    };

    handleChange = async () => {
        const { checked } = this.props;
        TrackingActions.jobcenterPlusRailcardToggle(`toggle-jcp-railcard:${!checked}`);
        this.props.onChange(!checked);
    }

    renderCustomLabel () {
        return (
            <span>
                <span>{ t('season.options.labels.railcardJobCentrePlus') }</span>
                <HelpIcon buttonClassName="railcard-help-icon"
                          icon={ 'info' }
                          heading={ t('help.railcardJobCentrePlus.title') }
                          body={ <section className="text-center">
                              <Icon icon="info margin-top margin-bottom otrl-xl" />
                              <div className="text-left">
                                <FormattedHTMLMessage message="help.jobcentreplus.message" />
                              </div>
                            </section> }
                />
            </span>
        );
    }

    render() {
        const { checked, disabled, onDisabledClick } = this.props;
        const onClickProps = disabled ? { onClick: onDisabledClick } : null;

        return (<ToggleInput name="railcardJobCentrePlus"
                className="railcardJobCentrePlusToggle"
                checked={checked}
                disabled={ disabled }
                label={ this.renderCustomLabel() }
                value="railcardJobCentrePlus"
                ariaLabel={ t('season.options.labels.railcardJobCentrePlus') }
                onChange={ this.handleChange }
                { ...onClickProps }
                srOnly={ t('season.options.labels.railcardJobCentrePlus') }
        />);
    }
}

export default RailcardJobCentrePlusCheckbox;



// WEBPACK FOOTER //
// ./src/components/seasonTicket/RailcardJobCentrePlusCheckbox.js